var _path, _path2, _path3, _rect, _circle, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUnlocked = function SvgUnlocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.8C0 2.149 1.567 0 3.5 0h21C26.433 0 28 2.149 28 4.8v30.4c0 2.651-1.567 4.8-3.5 4.8h-21C1.567 40 0 37.851 0 35.2V4.8Z",
    fill: "#28277E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.444 6.722h-1.889a2.833 2.833 0 0 0-2.833 2.834v14.166a2.833 2.833 0 0 0 2.834 2.833h1.888a2.833 2.833 0 0 0 2.834-2.833V9.556a2.833 2.833 0 0 0-2.834-2.834ZM13.555 2A7.556 7.556 0 0 0 6 9.556v14.166a7.556 7.556 0 0 0 7.556 7.556h1.888A7.556 7.556 0 0 0 23 23.722V9.556A7.556 7.556 0 0 0 15.444 2h-1.889Z",
    fill: "#2F5962"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#28277E",
    d: "M18.278 15.222H23v7.556h-4.722z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 18.222,
    width: 24,
    height: 20,
    rx: 4,
    fill: "#FFBF00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.999,
    cy: 26.222,
    fill: "#2F5962",
    r: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 29.717a1.63 1.63 0 0 1 3.25 0l.208 2.512a1.84 1.84 0 1 1-3.667 0l.209-2.512Z",
    fill: "#2F5962"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8Zm3.619 6.619-4 4a.868.868 0 0 1-.619.256.871.871 0 0 1-.62-.256l-2-2a.876.876 0 0 1 1.239-1.238L13 28.762l3.381-3.38a.876.876 0 0 1 1.238 1.237Z",
    fill: "#2F5962"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m17.619 26.619-4 4a.868.868 0 0 1-.62.256.87.87 0 0 1-.618-.256l-2-2a.876.876 0 0 1 1.238-1.238L13 28.762l3.382-3.38a.876.876 0 0 1 1.238 1.237Z",
    fill: "#fff"
  })));
};

export default SvgUnlocked;